module.exports = __webpack_public_path__ + "static/media/art10.4edc2d9f.png";